import React, { useState, useRef, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { COLEGIOS as COLEGIOS_DEFAULT } from '../data/colegios';

function useColegios() {
  const [colegios, setColegios] = useState(COLEGIOS_DEFAULT.map(c => ({ codigo: c.codigo, nombre: c.nombre })));
  useEffect(() => {
    getDocs(collection(db, 'colegios'))
      .then(snap => {
        if (!snap.empty) {
          setColegios(snap.docs.map(d => ({ codigo: d.data().codigo, nombre: d.data().nombre })).sort((a,b) => a.codigo.localeCompare(b.codigo)));
        }
      }).catch(() => {});
  }, []);
  return colegios;
}

export default function ColegioSelector({ value, onChange, nombreValue, esNuevo, onToggleNuevo }) {
  const colegios = useColegios();
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [highlighted, setHighlighted] = useState(0);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const wrapRef = useRef(null);

  const selected = colegios.find(c => c.codigo === value);
  const results = query ? colegios.filter(c => c.nombre.toLowerCase().includes(query.toLowerCase()) || c.codigo.includes(query)) : colegios;

  useEffect(() => { setHighlighted(0); }, [query]);

  function selectColegio(c) { onChange(c.codigo, c.nombre, false); setQuery(''); setOpen(false); }

  function handleKey(e) {
    if (!open) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setHighlighted(h => Math.min(h+1, results.length-1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setHighlighted(h => Math.max(h-1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); if (results[highlighted]) selectColegio(results[highlighted]); }
    else if (e.key === 'Escape') setOpen(false);
  }

  useEffect(() => {
    function handleClick(e) { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={wrapRef}>
      <div style={{ display: 'flex', gap: 0, marginBottom: 10, border: '1.5px solid rgba(0,45,98,.18)', borderRadius: 8, overflow: 'hidden' }}>
        <button type="button" onClick={() => onToggleNuevo(false)} style={{ flex: 1, padding: '7px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', border: 'none', fontFamily: 'inherit', background: !esNuevo ? 'linear-gradient(135deg,#002D62,#0a3d80)' : '#f9fafb', color: !esNuevo ? '#fff' : '#6b7280' }}>
          ✓ Colegio existente
        </button>
        <button type="button" onClick={() => onToggleNuevo(true)} style={{ flex: 1, padding: '7px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', border: 'none', borderLeft: '1.5px solid rgba(0,45,98,.18)', fontFamily: 'inherit', background: esNuevo ? 'linear-gradient(135deg,#b57a00,#F5A623)' : '#f9fafb', color: esNuevo ? '#fff' : '#6b7280' }}>
          + Colegio nuevo (apertura)
        </button>
      </div>

      {!esNuevo && (
        <div className="colegio-selector" style={{ position: 'relative' }}>
          {selected && !open ? (
            <div className="colegio-selected" onClick={() => { setOpen(true); setTimeout(() => inputRef.current?.focus(), 50); }}>
              <div className="colegio-selected-inner">
                <span className="colegio-codigo-tag">{selected.codigo}</span>
                <span className="colegio-nombre">{selected.nombre}</span>
              </div>
              <button className="colegio-clear" onClick={e => { e.stopPropagation(); onChange('', '', false); }}>×</button>
            </div>
          ) : (
            <input ref={inputRef} type="text" className="colegio-input" placeholder="Buscar por nombre o código SIGERD..." value={query} onChange={e => { setQuery(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onKeyDown={handleKey} autoComplete="off" />
          )}
          {open && (
            <div className="colegio-dropdown" ref={listRef}>
              {results.length === 0 ? <div className="colegio-empty">No se encontró ningún colegio</div> :
                results.map((c, i) => (
                  <div key={c.codigo} className={`colegio-option ${i === highlighted ? 'highlighted' : ''}`} onMouseDown={() => selectColegio(c)} onMouseEnter={() => setHighlighted(i)}>
                    <span className="colegio-codigo-tag">{c.codigo}</span>
                    <span className="colegio-opt-nombre">{c.nombre}</span>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}

      {esNuevo && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '9px 13px', fontSize: 12, color: '#78350f', fontWeight: 500 }}>
            Colegio sin código SIGERD. Se asignará cuando el MINERD apruebe la apertura.
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 10, fontWeight: 700, color: '#6b7280', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '.5px' }}>Nombre propuesto *</label>
            <input type="text" value={nombreValue || ''} onChange={e => onChange('NUEVO', e.target.value, true)} placeholder="Ej: Centro Educativo San Miguel" style={{ width: '100%', padding: '8px 11px', border: '1.5px solid rgba(181,122,0,.35)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fffdf5' }} />
          </div>
          {nombreValue && <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#15803d', fontWeight: 600 }}>✓ Se registrará como: {nombreValue}</div>}
        </div>
      )}
    </div>
  );
}
